"use client"

import { RequireAuth } from "@/components/require-auth"
import { UserPortalShell } from "@/components/user-portal-shell"

export default function UserLayout({ children }: { children: React.ReactNode }) {
  return <RequireAuth role="user"><UserPortalShell>{children}</UserPortalShell></RequireAuth>
}
